import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import reactT from '../../components/reactT';

function ShowAllModal(props) {
  const {children, filter, currentQuery} = props;
  const [show, setShow] = useState(false);
  const handleClose = (e) => {
    e.preventDefault();
    props.clearFilter();
    setShow(false);
  }
  const handleShow = (e) => {
    e.preventDefault();
    setShow(true);
  }
  const handleApplyFilters = (e) => {
    e.preventDefault();
    props.propHandleApplyFilters();
    setShow(false);
  }

  const allAreNull =
    Object.values(children).every(value => {
      // 👇️ check for multiple conditions
      if (value === null || value === undefined || value === '') {
        return true;
      }
      return false;
    });

  return (
    <>
      <a href="!#" className='btn-sm p-0' onClick={handleShow} rel="nofollow">
      {props.triggerLabel}
      </a>

      <Modal show={show} onHide={(e) => handleClose} dialogClassName="modal-md show-all-modal">
        <Modal.Header className="border-bottom-0">
          <Modal.Title as='h3'>{reactT('Search in')+' '+props.title}</Modal.Title>
          <button
            type="button"
            className="close"
            onClick={handleClose}
            aria-label="Close"
          >
          </button>
          {filter}
        </Modal.Header>
        {currentQuery}
        <Modal.Body>
          {allAreNull !== true ? children : <p>{reactT('No results found.')}</p>}
        </Modal.Body>
        <Modal.Footer className="align-items-center justify-content-between border-0 mb-md-4 pb-md-3 pt-md-3 mt-md-3">
          <button className={props.selectedCount > 0 ? 'btn btn-white m-0 px-0 border border-dark' : 'btn btn-white m-0 px-0 border border-dark disabled'} onClick={props.onClear}>{reactT('Clear')+' (' + props.selectedCount+')'}</button>
          <button className="btn btn-secondary m-0 px-0 border border-secondary" onClick={handleApplyFilters}>{reactT('Apply')}</button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ShowAllModal;
